'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function MessageIfExists(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === undefined ? _reactIntl.FormattedMessage : _ref$component,
      intl = _ref.intl,
      props = _objectWithoutProperties(_ref, ['component', 'intl']);

  if (intl.messages[props.id]) {
    return _react2.default.createElement(Component, props);
  }
  return null;
}

MessageIfExists.propTypes = {
  id: _react.PropTypes.string.isRequired,
  intl: _reactIntl.intlShape,
  component: _react2.default.PropTypes.oneOfType([_react.PropTypes.instanceOf(_react2.default.Component), _react2.default.PropTypes.func]),
  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node, _react2.default.PropTypes.func])
};

exports.default = (0, _reactIntl.injectIntl)(MessageIfExists);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/localization-message-if-exists/lib/components/MessageIfExists.component.js
// module id = 1423
// module chunks = 1